import styled from "styled-components";
import { responsive } from "theme/reponsive";

export const SchoolsCommentsContainer = styled.div`
   background-color: #ffffff;
   margin-top: 30px;
   box-shadow: 0 3px 25px rgb(0 0 0 / 6%);
   background-color: #fff;
   border-radius: 4px;
   padding: 30px;
   margin: 5px 0;

   .review-title {
      margin: 30px 0;
   }

   .school--rating {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      .subject {
         margin: 5px 0;
      }
   }
`;

export const CommentContainer = styled.div`
   padding: 30px 0px;

   border-bottom: 1px solid #eee9e9;

   .school--comment {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
   }

   .comment--user {
      background-color: ${({ theme }) => theme.colors?.primary};
      height: 70px;
      width: 70px;
      color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      font-size: 2rem;
      font-weight: 600;
   }

   .subject {
      color: #636363;
      font-size: 14.5px;
   }

   .comment-text {
      color: #636363;
      font-size: 1.5rem;
      line-height: 2;
   }

   .date-text {
      color: #636363;
      font-size: 1.4rem;
   }

   .rating {
      margin: 0px 0;
      width: 100%;

      span:not(:first-child) {
         margin-left: 5px;
         border-radius: 5px;
      }
   }

   h3 {
      color: #636363;
      font-weight: 500;
      font-size: 1.7rem;
   }
`;

export const RatingContainer = styled.div`
   .school--rating {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
   }
`;

export const NewSchoolsCommentsContainer = styled.div`
   width: 100%;
   h4.title-count {
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
      color: #151f34;
   }

   ${responsive("$medium")`
      h4.title-count {
          font-size:  18px
   `}
`;

export const NewCommentContainer = styled.div`
   margin-top: 2.4rem;

   .comment-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &_user {
         display: flex;
         align-items: center;

         p {
            margin-left: 12px;
            font-size: 14px;
            line-height: 21px;
            color: #151f34;
            font-weight: 600;
         }
      }

      &_date {
         font-size: 14px;
         line-height: 16px;
         color: #6d7a98;
      }
   }

   .comment-description {
      margin-top: 12px;
      font-size: 14px;
      line-height: 24px;
      color: #3d414b;
   }
`;

export const AddReviewContainer = styled.div`
   width: 100%;
   height: 462px;
   padding: 24px;
   background: #fafafa;
   border: 1px solid #f1f1f1;
   border-radius: 8px;
   text-transform: capitalize;

   .review-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #151f34;
      margin-bottom: 20px;
   }
`;
